<template>
    <PageRelatorio namePage="rel-agenda-ausentes" title="Agendamentos ausentes" subtitle="Informe o profissional e o período para obter os dados"
     permissions="" :fncCarregaRel="carregarRelatorio">

        <v-data-table class="tabela-rel-agenda-ausentes" hide-default-footer :headers="colunasRel" :items="dadosRel"
         no-data-text="Nenhum registro encontrado" :items-per-page="-1" :header-props="{sortByText: 'Ordenar por...'}">
            <template v-slot:[`item.agd_data_hora`]="{ item }">
                {{ functions.getDataHoraFormatada(item.agd_data_hora, true) }}
            </template>
        </v-data-table>

    </PageRelatorio>
</template>

<script>
import PageRelatorio from '@/components/templates/PageRelatorio'
import consts from '@/globalFiles/consts'
import functions from '@/globalFiles/functions'
import axios from 'axios'

export default {
    name: 'RelAgendaAusentes',
    components: {
        PageRelatorio
    },
    data() {
        return {
            functions,
            dadosRel: [],
            colunasRel: [
                {
                    text: 'Data/Hora',
                    value: 'agd_data_hora'
                },
                {
                    text: 'Serviço',
                    value: 'srv_titulo'
                },
                {
                    text: 'Cliente',
                    value: 'cliente'
                }
            ]
        }
    },
    methods: {
        carregarRelatorio(profissional, dataIni, dataFim) {
            this.dadosRel = []

            axios.put(`${consts.baseApiUrl}/rel_agenda_ausentes`, {
                    profissional: profissional,
                    data_ini: dataIni,
                    data_fim: dataFim
                })
                .then(r => {
                    this.dadosRel = r.data.data
                })
                .catch(err => {
                    functions.showError(err)
                })
        }
    }
}
</script>

<style>

</style>